
import React, { useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CenterModal from "../Components/CenterModal";
import API from '../Services/Report';
import APIS from "../Services/TaxRate";
import API1 from "../Services/DiscountReport";
import * as XLSX from "xlsx";
import css from "../../src/Report/style.css";
import { faL } from "@fortawesome/free-solid-svg-icons";


const FinanceReportCopy = () => {
    const [selectedCenter, setSelectedCenter] = useState([]);

    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 90);
    const formattedPastDate = pastDate.toISOString().split("T")[0];
    const [finance, setFinance] = useState([]);
    const [recordsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [payload, setPayload] = useState({});
    const [selectedReport, setSelectedReport] = useState(null);
    const [payment, setPayment] = useState([]);
    const [partyGst, setPartyGst] = useState([]);
    const [search, setSearch] = useState({
        searchText: "",
        from_date: formattedPastDate,
        to_date: formattedToday,
    });
    const [totalRecords, setTotalRecords] = useState(0);
    const perPage = 10;
    const [taxRate, setTaxRate] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [resetTrigger, setResetTrigger] = useState(false);
    const [activeTab, setActiveTab] = useState("party");
    const [reportType, setReportType] = useState(null);
    const [radioFilter, setRadioFilter] = useState("");
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0)
    const [totalPartyCount, setTotalPartyCount] = useState(0)
    const [discountSummary, setDiscountSummary] = useState({})
    const [reverseCoins, setReverseCoins] = useState([])
    const [reverselCount, setReverselCount] = useState(0)
    const [discountType, setDiscountType] = useState(null);

    const [show, setShow] = useState(false);
    const [showCoupon, setShowCoupon] = useState(false);
    const [showAdRecharge, setshowAdRecharge] = useState(false);
    const [showAdCombo, setShowAdCombo] = useState(false);
    const [showParty, setShowParty] = useState(false);

    const [consolidatedCuoponReport, setConsolidatedCuoponReport] = useState([]);
    const [showCouponDetails, setShowCouponDetails] = useState(false);
    const [showPackageDetails, setShowPackageDetails] = useState(false);
    const [playPointsDiscount, setPlayPointsDiscount] = useState([]);
    const [playPointsDiscountCount, setPlayPointsDiscountCount] = useState(0);

    const [pointsDiscountReport, setPointsDiscountReport] = useState([]);
    const [pointsDiscountReportCount, setPointsDiscountReportCount] = useState(0);
    const [partyDiscountReport, setPartyDiscountReport] = useState([]);
    const [partyDiscountReportCount, setPartyDiscountReportCount] = useState(0);
    const [financeProduct, setFinanceProduct] = useState([]);
    const [productPage, setProductPage] = useState(1);
    const [productId, setProductId] = useState(null);
    const [productLimit] = useState(10);
    //  const [productPage, setProductPage] = useState(1);
    const [productTotalPages, setProductTotalPages] = useState(1);

    const tabs = [
        { id: "party", label: "Party Report (GST)", icon: "mdi mdi-account-group" },
        { id: "non-party", label: "Non-Party Report (GST)", icon: "mdi mdi-file-percent" },
        { id: "payment", label: "Payment Collection Report", icon: "mdi mdi-currency-rupee" },
        { id: "Discount-Report", label: "Discount Report", icon: "mdi mdi-sale" },
        { id: "Reversel-Report", label: "Reversel Report", icon: "mdi mdi-sale" },
    ];
    const [filters, setFilters] = useState({
        startDate: formattedPastDate,
        endDate: formattedToday,
        limit: '10',
        centers: []
    });
    useEffect(() => {
        if (reportType === "report1") {
            getFinanceReport();
            bindGetTaxtRate();
        }
        else if (reportType === "report2") {
            getPaymentSummerReport();
        }
        getpartyReport();
        bindGetTaxtRate();

    }, [resetTrigger]);

    const getFinanceReport = async (page = 1) => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payloadData = {
                start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                page_number: page,
                limit: recordsPerPage,
            };
            //console.log("payload..", payloadData)
            setPayload(payloadData);
            const response = await API.addFinanceReport(payloadData);

            if (response?.status === 200 && Array.isArray(response?.data?.result)) {
                const totalCount = Number(response?.data?.total_count ?? 0);
                setTotalCount(totalCount)
                setFinance(response.data.result);
                setCurrentPage(page);
                setTotalPages(Math.ceil(totalCount / recordsPerPage));
            } else {
                toast.error(response?.data?.message || "No finance report found");
                setFinance([]);
                setTotalPages(1);
            }
        } catch (error) {
            toast.error("Something went wrong while fetching category report");
            setFinance([]);
            setTotalPages(1);
        }
    };

    const getFinanceProductByCategory = async (id, page = 1) => {
        try {
            setFinanceProduct([]);

            setProductId(id);
            const payload1 = {
                ...payload,
                product_type_id: id,
                page_number: page,
                limit: productLimit,
            };
            const response = await API.getFinanceProductType(payload1);
            if (response?.status === 200 && Array.isArray(response?.data?.result)) {
                const totalCount = Number(response?.data?.total_count ?? 0);
                setFinanceProduct(response.data.result);
                setProductPage(page);
                setProductTotalPages(Math.ceil(totalCount / productLimit));
            } else {
                toast.error(response?.data?.message || "No finance report found");
                setFinanceProduct([]);
                setProductTotalPages(1);
            }
        } catch (error) {
            console.error("Error fetching product data:", error);
            toast.error("Failed to fetch product details");
        }
    };


    const getFinanceProductId = async (page = 1) => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;
            const payload1 = {
                ...payload,
                start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                page_number: page,
                limit: recordsPerPage,
            };
            // console.log("Product payload:", payload1);
            const response = await API.getProductWiseGstReport(payload1);
            //console.log("Finance product data:", response?.data);
            if (response?.status === 200 && Array.isArray(response?.data?.result)) {
                const totalCount = Number(response?.data?.total_count ?? 0);
                setTotalCount(totalCount)
                setFinance(response.data.result);
                setCurrentPage(page);
                setTotalPages(Math.ceil(totalCount / recordsPerPage));
            } else {
                toast.error(response?.data?.message || "No product report found");
                setFinance([]);
                setTotalPages(1);
            }
        } catch (error) {
            console.error("Error fetching product data:", error);
            toast.error("Failed to fetch product report");
            setFinance([]);
            setTotalPages(1);
        }
    };

    const getPaymentSummerReport = async (page = 1) => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;
            const payloadData = {
                 start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
            };
            const response = await API.getPaymentSummryReport(payloadData);
            if (response?.status === 200 && Array.isArray(response?.data?.result)) {
                const resultData = response?.data?.result;
                //  console.log("........", response?.data)
                setPayment(resultData);
            } else {
                toast.error(response?.data?.message || "No finance report found");
                setPayment([]);
            }
        } catch (error) {
            toast.error("Something went wrong while fetching report");
            setFinance([]);
            setTotalPages(1);
        }
    };

    const handleRadioFilterChange = async (filterType) => {

        setRadioFilter(filterType);
        setFinance([]);

        if (filterType === "productCategory") {
            await getFinanceReport(1);

        } else if (filterType === "product") {
            await getFinanceProductId(1);

        } else if (filterType === "adhock") {
            getDiscountSummaryData();
            setShowCoupon(false);
            setShow(true);

        }
        else if (filterType === "coupon") {
            //console.log("coupon");
            setShowCoupon(true);
            setShowAdCombo(false);
            setShowParty(false);

            // setshow
            setshowAdRecharge(false);
            setShow(false);
            getConsolidatedCuoponReport(1);
        }
    };

    const getConsolidatedCuoponReport = async (page = 1) => {

        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;
            const payloadData = {
                start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                page_number: page,
                limit: perPage,
            };

            const response = await API1.getConsolidatedCuoponReport(payloadData);

            if (response.data?.success) {
                setConsolidatedCuoponReport(response?.data.result || []);

            } else {
                setConsolidatedCuoponReport([]);
            }

        } catch (error) {
            toast.error("Something went wrong while fetching report");
            setConsolidatedCuoponReport([]);
        }
    };

    const handlePageChange = (page) => {
        if (activeTab === "Discount-Report") {
            if (radioFilter === "adhock") {
                switch (discountType) {
                    case "party_discount":
                        getPartyDiscountReport(page);
                        break;
                    case "recharge":
                        getPlayPointsDiscountReport(page);
                        break;
                    case "combo_product":
                        getProductDiscountReport(page);
                        break;
                    default:
                        console.warn("Invalid discountType for adhock");
                }
            }
            return;
        }
        if (activeTab === "party") {
            getpartyReport(page);
            return;
        }
        if (activeTab === "Reversel-Report") {
            getReverselReport(page);
            return;
        }

        if (radioFilter === "productCategory") {
            getFinanceReport(page);
        } else {
            getFinanceProductId(page);
        }
    };


    const getPageNumbers = () => {
        let pages = [];
        for (let i = 1; i <= totalPages; i++) pages.push(i);
        return pages;
    };

    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };
    const bindGetTaxtRate = async () => {
        try {
            const basePayload = {
                limit: perPage,
                pageNumber: currentPage,
                is_recipe: 0,
            };
            if (selectedStatus !== "") {
                basePayload.is_active = selectedStatus;
            }
            const response = await APIS.getTaxRate(basePayload);
            const details = response?.data?.data;
            setTaxRate(details?.rows || []);
            setTotalRecords(details?.count ?? 0);
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection.");
            } else if (error.response.status === 403) {
                window.location.replace("/Login");
                toast.error("Authorization error. Redirecting to login.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        handleClearFilter();

        resetOtherStates();

        switch (tabId) {
            case "party":
                setSelectedReport(null);
                break;

            case "non-party":
                setSelectedReport("report1");
                bindGetTaxtRate();
                break;

            case "payment":
                setSelectedReport("report2");
                getPaymentSummerReport();
                break;

            case "Discount-Report":
                setSelectedReport("report_discount");
                break;

            case "Reversel-Report":
                setSelectedReport("report_reverse");
                getReverselReport();
                break;

            default:
                break;
        }
    };

    const resetOtherStates = () => {
        setShow(false);
        setshowAdRecharge(false);
        setShowAdCombo(false);
        setShowCoupon(false);
        setShowParty(false);
    };


    const handleFilterChange = (e) => {
        const { name, value } = e.target;

        setFilters(prev => ({
            ...prev,
            [name]: value
        }));

    };

    const handleApplyFilter = () => {

        switch (activeTab) {

            case "non-party": {
                if (radioFilter === "productCategory") {
                    getFinanceReport(1);
                }
                else if (radioFilter === "product") {
                    getFinanceProductId(1);
                }
                else {
                    toast.warning("Please select Product Category or Product filter first");
                }
                break;
            }

            case "Reversel-Report": {
                getReverselReport(1);
                break;
            }
            case "payment": {
                getPaymentSummerReport(1);
                break;
            }
            case "party": {
                getpartyReport(1);
                break;
            }
            case "Discount-Report": {

                if (radioFilter === "adhock" && discountType === "recharge") {
                    getPlayPointsDiscountReport(1);
                }
                else if (radioFilter === "adhock" && discountType === "party_discount") {
                    getPartyDiscountReport(1)
                }
                else if (radioFilter === "adhock" && discountType === "combo_product") {
                    getProductDiscountReport(1);
                }
                else if (radioFilter === "coupon" && discountType === "combo_product") {
                    console.log("Fetching: Coupon Combo Product Report");
                }

                else if (radioFilter === "coupon") {
                    getConsolidatedCuoponReport(1);
                }
                else {
                    toast.warning("Invalid filter combination selected");
                }

                break;
            }

            default:
                break;
        }
    };

    const getpartyReport = async (page = 1) => {

        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;
            const payloadData = {
                start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                page_number: page,
                limit: perPage,
            };
            // console.log("payload..", payloadData)
            setPayload(payloadData);
            const response = await API.getPartyGstReport(payloadData);
            if (response?.status === 200 && Array.isArray(response?.data?.result)) {
                const totalCount = response?.data?.result?.length ?? 0;
                // console.log('totalCount party', totalCount)
                // console.log('response?.data?.result', response?.data?.result);
                setTotalPartyCount(totalCount)
                setPartyGst(response?.data?.result)
                setCurrentPage(page);
                setTotalPages(Math.ceil(totalCount / recordsPerPage));
                //  setTotalParty(totalCount)
            } else {
                toast.error(response?.data?.message || "No finance report found");
                setPartyGst([]);
                setTotalPages(1);
            }
        } catch (error) {
            toast.error("Something went wrong while fetching category report");
            setFinance([]);
            setTotalPages(1);
        }
    };

    const getReverselReport = async (page = 1) => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;
            const payloadData = {
                start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                page_number: page,
                limit: recordsPerPage,
            };

            setPayload(payloadData);
            const response = await API.getReverselPointReport(payloadData);
            if (response?.status === 200 && Array.isArray(response?.data?.result)) {
                const totalCount = response?.data?.result?.length ?? 0;

                setReverselCount(totalCount)
                setReverseCoins(response?.data?.result || [])
                setCurrentPage(page);
                setTotalPages(Math.ceil(totalCount / recordsPerPage));
            } else {
                toast.error(response?.data?.message || "No finance report found");
                setReverseCoins([]);
                setTotalPages(1);
            }
        } catch (error) {
            toast.error("Something went wrong while fetching category report");
            setFinance([]);
            setTotalPages(1);
        }
    };

    const getPlayPointsDiscountReport = async (page = 1) => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payloadData = {
                start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                page_number: page,
                limit: perPage,
            };
            const response = await API1.getPlayPointsDiscountReport(payloadData);
            if (response?.status === 200 && Array.isArray(response?.data?.result)) {
                const result = response.data.result;
                const totalRecords = response?.data?.total_count ?? 0;
                //const dataRows = result.slice(1);
                setPlayPointsDiscount(result);
                setPlayPointsDiscountCount(totalRecords);
                setShowAdCombo(false);
                setTotalPages(Math.ceil(totalRecords / recordsPerPage));
                setCurrentPage(page);
            }
            else {
                toast.error("No PlayPointsDiscount data found");
                setPlayPointsDiscount([]);
                setTotalPages(1);
            }
        } catch (error) {
            toast.error("Error fetching PlayPointsDiscount report");
            setPlayPointsDiscount([]);
            setTotalPages(1);
        }
    };
    const getProductDiscountReport = async (page = 1) => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payloadData = {
                start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                page_number: page,
                limit: recordsPerPage,
            };

            const response = await API1.getProductDiscountReport(payloadData);

            if (response?.data?.success === true && Array.isArray(response.data.result)) {

                const reportList = response.data.result;
                const totalCount = response.data.total_count || 0;

                setPointsDiscountReport(reportList);
                setPointsDiscountReportCount(totalCount);
                setShowAdCombo(true);
                setshowAdRecharge(false);
                setTotalPages(Math.ceil(totalCount / recordsPerPage));

            } else {
                toast.error("No Product Discount data found");
                setPointsDiscountReport([]);
                setPointsDiscountReportCount(0);
                setTotalPages(1);
            }

        } catch (error) {
            console.error(error.message);
            toast.error(error?.response?.data?.message || error.message);
            // toast.error("Error fetching Product Discount report");
            setPointsDiscountReport([]);
            setPointsDiscountReportCount(0);
            setTotalPages(1);
        }
    };

    const getPartyDiscountReport = async (page = 1) => {

        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payloadData = {
                start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                page_number: page,
                limit: recordsPerPage,
            };

            const response = await API1.getPartyDiscountReport(payloadData);

            if (response?.data?.success === true && Array.isArray(response.data.result)) {

                const reportList = response.data.result;
                const totalCount = response.data.total_count || 0;

                setPartyDiscountReport(reportList);
                setPartyDiscountReportCount(totalCount);

                setCurrentPage(page);
                setTotalPages(Math.ceil(totalCount / recordsPerPage));

                setShowParty(true);

            } else {
                toast.error("No Party Discount data found");
                setPartyDiscountReport([]);
                setPartyDiscountReportCount(0);
            }

        } catch (error) {
            console.error(error.message);
            toast.error(error?.response?.data?.message || "Error fetching party discount report");

            setPartyDiscountReport([]);
            setPartyDiscountReportCount(0);
        }
    };

    const getDiscountSummaryData = async () => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payloadData = {
                start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                page_number: 1,
                limit: recordsPerPage
            };
            setLoading(true);

            const response = await API.getDiscountSummary(payloadData);
            if (response?.data?.result?.length > 0) {
                const data = response.data.result[0];
                const parsedData = {
                    recharge: JSON.parse(data.recharge || "{}"),
                    combo_product: JSON.parse(data.combo_product || "{}"),
                    party_discount: JSON.parse(data.party_discount || "{}"),
                };
                //  console.log("Parsed discount summary:", parsedData);
                setDiscountSummary(parsedData);
            } else {
                toast.warn("No discount summary data found");
                setDiscountSummary({});
            }
        } catch (error) {
            console.error("Error fetching discount summary:", error);
            toast.error("Failed to load discount summary");
        } finally {
            setLoading(false);
        }
    };

    const handleCardClick = (type) => {
        setDiscountType(type);
        if (type === "recharge" && radioFilter === "adhock") {
            getPlayPointsDiscountReport(1);
            setshowAdRecharge(true);
            setShowAdCombo(false);
            setShowParty(false);
        }
        else if (type === "combo_product" && radioFilter === "adhock") {
            setPlayPointsDiscount([]);
            setshowAdRecharge(false);
            setShowParty(false);
            getProductDiscountReport(1);
        }
        else if (type === "party_discount" && radioFilter === "adhock") {

            getPartyDiscountReport(1);
            setshowAdRecharge(false);
            setShowAdCombo(false);
            setShowParty(show);
        }

    };

    const [clearApplied, setClearApplied] = useState(false);

    useEffect(() => {
        if (!clearApplied) return;

        switch (activeTab) {

            case "non-party":
                radioFilter === "product"
                    ? getFinanceProductId(1)
                    : getFinanceReport(1);
                break;

            case "party":
                getpartyReport(1);
                break;

            case "payment":
                getPaymentSummerReport(1);
                break;

            case "Reversel-Report":
                getReverselReport(1);
                break;

            case "Discount-Report":
                if (radioFilter === "adhock" && discountType === "recharge")
                    getPlayPointsDiscountReport(1);
                else if (radioFilter === "adhock" && discountType === "party_discount")
                    getPartyDiscountReport(1);
                else if (radioFilter === "adhock" && discountType === "combo_product")
                    getProductDiscountReport(1);
                else if (radioFilter === "coupon")
                    getConsolidatedCuoponReport(1);
                break;

            default:
                break;
        }

        setClearApplied(false);

    }, [clearApplied]);

    const handleClearFilter = () => {
        setFilters({
            startDate: formattedPastDate,
            endDate: formattedToday,
            limit: "10",
            centers: [],
        });

        setSelectedCenter([]);
        // setRadioFilter("productCategory");
        setResetTrigger(p => p + 1);

        setClearApplied(true);
    };



    const downloadCSV = async () => {

        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;
            const payloadData = {
                start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                limit: totalCount,
            };

            let response, sheetName, fileName;
            if (radioFilter === "productCategory" && activeTab === "non-party") {
                response = await API.addFinanceReport(payloadData);
                sheetName = "ProductCategoryReport";
                fileName = "ProductCategoryReport.xlsx";
            } else if (radioFilter === "product" && activeTab === "non-party") {
                response = await API.getProductWiseGstReport(payloadData);
                sheetName = "ProductReport";
                fileName = "ProductReport.xlsx";
            } else if (activeTab === "party") {
                response = await API.getPartyGstReport(payloadData);
                sheetName = "PartyReport";
                fileName = "PartyReport.xlsx";

            } else if (activeTab === "payment") {
                response = await API.getPaymentSummryReport(payloadData);
                sheetName = "PaymentCollectionReport";
                fileName = "PaymentCollectionReport.xlsx";
            }
            // else if (activeTab === "Discount-Report") {
            //    console.log('ddddddddddddddddddddddddddddd');
            //     response = await API.getDiscountSummary(payloadData);
            //     sheetName = "DiscoountReport";
            //     fileName = "DiscoountReport.xlsx";
            // }
            else if (activeTab === "Reversel-Report") {

                const centerlist = Array.isArray(selectedCenter)
                    ? selectedCenter.join(",")
                    : selectedCenter;
                const payloadData = {
                    start_date: filters.startDate || null,
                    end_date: filters.endDate || null,
                    location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                    page_number: 1,
                    limit: reverselCount
                };

                response = await API.getReverselPointReport(payloadData);
                sheetName = "ReverselReport";
                fileName = "ReverselReport.xlsx";
            }
            else if (radioFilter === "adhock" && discountType === "recharge" && activeTab === "Discount-Report") {

                const centerlist = Array.isArray(selectedCenter)
                    ? selectedCenter.join(",")
                    : selectedCenter;
                const payloadData = {
                    start_date: filters.startDate || null,
                    end_date: filters.endDate || null,
                    location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                    page_number: 1,
                    limit: playPointsDiscountCount
                };

                response = await API1.getPlayPointsDiscountReport(payloadData);
                sheetName = "RechargeReport";
                fileName = "RechargeReport.xlsx";
            }

            else if (discountType === "combo_product" && activeTab === "Discount-Report" && radioFilter === "adhock") {

                const centerlist = Array.isArray(selectedCenter)
                    ? selectedCenter.join(",")
                    : selectedCenter;
                const payloadData = {
                    start_date: filters.startDate || null,
                    end_date: filters.endDate || null,
                    location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                    page_number: perPage,
                    limit: pointsDiscountReportCount
                };

                response = await API1.getProductDiscountReport(payloadData);
                sheetName = "ComboProductDiscountReport";
                fileName = "ComboProductDiscountReport.xlsx";
            }

            else if (discountType === "party_discount" && activeTab === "Discount-Report" && radioFilter === "adhock") {

                const centerlist = Array.isArray(selectedCenter)
                    ? selectedCenter.join(",")
                    : selectedCenter;
                const payloadData = {
                    start_date: filters.startDate || null,
                    end_date: filters.endDate || null,
                    location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                    page_number: perPage,
                    limit: partyDiscountReportCount
                };

                response = await API1.getPartyDiscountReport(payloadData);
                sheetName = "PartyDiscountReport";
                fileName = "PartyDiscountReport.xlsx";
            }

            else {
                toast.warning("Please select Product Category or Product filter first!");
                return;
            }
            const result = response?.data?.result || [];
            if (!result.length) {
                toast.error("No data found to download!");
                return;
            }
            const worksheet = XLSX.utils.json_to_sheet(result);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
            XLSX.writeFile(workbook, fileName);
            // toast.success(`${sheetName} downloaded successfully!`);
        } catch (error) {
            console.error("Error downloading Excel:", error);
            toast.error("Failed to download report. Please try again.");
        }
    };

    const getCardStyle = (type, bg) => ({
        background: bg,
        borderRadius: "10px",
        cursor: "pointer",
        padding: "15px",
        width: "32%",
        border: discountType === type ? "2px solid #1976d2" : "2px solid transparent",
        boxShadow:
            discountType === type
                ? "0 4px 12px rgba(25,118,210,0.3)"
                : "0 2px 6px rgba(0,0,0,0.1)",
        transform: discountType === type ? "scale(1.03)" : "scale(1)",
        transition: "all 0.2s ease",
    });

    const [couponDetailList, setCouponDetailList] = useState([]);
    const [packageDetailList, setPackageDetailList] = useState([]);

    const handleClickOpenrecharge = async () => {
        const centerlist = Array.isArray(selectedCenter)
            ? selectedCenter.join(",")
            : selectedCenter;

        const payloadData = {
            start_date: filters.startDate || null,
            end_date: filters.endDate || null,
            location_id: centerlist && centerlist.length > 0 ? centerlist : null,
            page_number: 1,
            limit: recordsPerPage
        };

        const response = await API1.getPlayPointsCuoponReport(payloadData);

        setCouponDetailList(response.data.result.slice(1));
        setShowCouponDetails(true);
    };

    const handleClickOpenPackage = async () => {
        const centerlist = Array.isArray(selectedCenter)
            ? selectedCenter.join(",")
            : selectedCenter;

        const payloadData = {
            start_date: filters.startDate || null,
            end_date: filters.endDate || null,
            location_id: centerlist && centerlist.length > 0 ? centerlist : null,
            page_number: 1,
            limit: recordsPerPage
        };
        const response = await API1.getPackageCuoponReport(payloadData);

        setPackageDetailList(response?.data?.result);
        setShowPackageDetails(true);
    };

    const downloadCSVRecharge = async () => {
        try {

            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payloadData = {
                start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                page_number: 1,
                limit: recordsPerPage
            };
            const response = await API1.getPlayPointsCuoponReport(payloadData);
            const result = response.data.result.slice(1) || [];

            if (!result.length) {
                toast.error("No data found!");
                return;
            }
            const worksheet = XLSX.utils.json_to_sheet(result);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Recharge");
            XLSX.writeFile(workbook, "RechargeReport.xlsx");
        } catch (error) {
            console.error("Error downloading Excel:", error);
        }
    };
    const downloadCSVPackage = async () => {
        try {

            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payloadData = {
                start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                page_number: 1,
                limit: recordsPerPage
            };
            const response = await API1.getPackageCuoponReport(payloadData);

            const result = response?.data?.result || [];

            if (!result.length) {
                toast.error("No data found!");
                return;
            }
            const worksheet = XLSX.utils.json_to_sheet(result);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Package");
            XLSX.writeFile(workbook, "PackageReport.xlsx");
        } catch (error) {
            console.error("Error downloading Excel:", error);
        }
    };

    const getProductPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;
        if (productTotalPages <= maxVisible) {
            for (let i = 1; i <= productTotalPages; i++) pages.push(i);
        } else {
            if (productPage <= 3) pages.push(1, 2, 3, "...", productTotalPages);
            else if (productPage >= productTotalPages - 2)
                pages.push(1, "...", productTotalPages - 2, productTotalPages - 1, productTotalPages);
            else
                pages.push(1, "...", productPage - 1, productPage, productPage + 1, "...", productTotalPages);
        }
        return pages;
    };
    return (
        <div>

            <div className="modern-nav-tabs">
                {tabs.map(tab => (
                    <div
                        key={tab.id}
                        className={`modern-tab ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => handleTabChange(tab.id)}
                        style={{ marginRight: "10px" }}
                    >
                        <i className={tab.icon}></i>
                        {tab.label}
                    </div>
                ))}
            </div>

            {(activeTab === "non-party") && (
                <div className="radio-filter-section mt-3">
                    <div className="radio-filter-title">Filter By:</div>
                    <div className="radio-filter-options">
                        <div
                            className={`radio-option ${radioFilter === "productCategory" ? "selected" : ""}`}
                            onClick={() => handleRadioFilterChange("productCategory")}>
                            <input
                                type="radio"
                                id="productCategory"
                                name="radioFilter"
                                value="productCategory"
                                checked={radioFilter === "productCategory"}
                                onChange={() => handleRadioFilterChange("productCategory")}
                            />
                            <label htmlFor="productCategory">Product Category</label>
                        </div>
                        <div
                            className={`radio-option ${radioFilter === "product" ? "selected" : ""}`}
                            onClick={() => handleRadioFilterChange("product")}>
                            <input
                                type="radio"
                                id="product"
                                name="radioFilter"
                                value="product"
                                checked={radioFilter === "product"}
                                onChange={() => handleRadioFilterChange("product",)}
                            />
                            <label htmlFor="product">Product</label>
                        </div>
                    </div>
                </div>
            )}

            {(activeTab === "Discount-Report") && (
                <div className="radio-filter-section mt-3">
                    <div className="radio-filter-title">Filter By:</div>
                    <div className="radio-filter-options">
                        <div
                            className={`radio-option ${radioFilter === "adhock" ? "selected" : ""}`}
                            onClick={() => handleRadioFilterChange("adhock")}>
                            <input
                                type="radio"
                                id="adhock"
                                name="radioFilter"
                                value="adhock"
                                checked={radioFilter === "adhock"}
                                onChange={() => handleRadioFilterChange("adhock")}
                            />
                            <label htmlFor="productCategory">Ad-Hock</label>
                        </div>
                        <div
                            className={`radio-option ${radioFilter === "coupon" ? "selected" : ""}`}
                            onClick={() => handleRadioFilterChange("coupon")}>
                            <input
                                type="radio"
                                id="product"
                                name="radioFilter"
                                value="coupon"
                                checked={radioFilter === "coupon"}
                                onChange={() => handleRadioFilterChange("coupon",)}
                            />
                            <label htmlFor="product">Coupon</label>
                        </div>
                    </div>
                </div>
            )}

            {show === true && (

                <div className="card p-0">
                    <div className="p-4">
                        {loading ? (
                            <p className="text-center fw-semibold">Loading...</p>
                        ) : discountSummary && Object.keys(discountSummary).length > 0 ? (
                            <div className="d-flex flex-wrap justify-content-between">
                                <div
                                    style={getCardStyle("recharge", "#e8f5e9")}
                                    onClick={() => handleCardClick("recharge")}>
                                    <h6 className="fw-bold text-uppercase mb-2">Recharge</h6>
                                    <hr className="my-2" />
                                    <p className="mb-1 fw-semibold">
                                        Count: {discountSummary?.recharge?.count || 0}
                                    </p>
                                    <p className="mb-0 fw-semibold">
                                        Amount: <span className="mdi mdi-currency-rupee"></span>
                                        {discountSummary?.recharge?.amount || 0}
                                    </p>
                                </div>
                                <div
                                    style={getCardStyle("combo_product", "#fff8e1")}
                                    onClick={() => handleCardClick("combo_product")}
                                >
                                    <h6 className="fw-bold text-uppercase mb-2">Combo Product</h6>
                                    <hr className="my-2" />
                                    <p className="mb-1 fw-semibold">
                                        Count: {discountSummary?.combo_product?.count || 0}
                                    </p>
                                    <p className="mb-1 fw-semibold">

                                        Amount: {discountSummary?.combo_product?.amount || 0}
                                    </p>
                                </div>

                                <div
                                    style={getCardStyle("party_discount", "#e3f2fd")}
                                    onClick={() => handleCardClick("party_discount")}
                                >
                                    <h6 className="fw-bold text-uppercase mb-2">Party Discount</h6>
                                    <hr className="my-2" />
                                    <p className="mb-1 fw-semibold">
                                        Count: {discountSummary?.party_discount?.count || 0}
                                    </p>
                                    <p className="mb-1 fw-semibold">
                                        Count: {discountSummary?.party_discount?.amount || 0}
                                    </p>
                                </div>


                            </div>
                        ) : (
                            <p className="text-center fw-semibold m-0">
                                No summary data available
                            </p>
                        )}
                    </div>
                </div>
            )}


            {(activeTab === "non-party" || activeTab === "payment" || activeTab === "party" || activeTab === "Discount-Report" || activeTab === "Reversel-Report") && (
                <div className="modern-filter-section mt-3">
                    <div className="filter-title">
                        <i className="mdi mdi-filter-variant-plus"></i>
                        <span>Filter Options</span>
                    </div>
                    <div className="row g-3">
                        <div className="col-md-4">
                            <div className="filter-group">
                                <label className="filter-label">Start Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="startDate"
                                    value={filters.startDate || ""}
                                    onChange={handleFilterChange}
                                    min={formattedPastDate}
                                    max={formattedToday}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="filter-group">
                                <label className="filter-label">End Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="endDate"
                                    value={filters.endDate || ""}
                                    onChange={handleFilterChange}
                                    min={formattedPastDate}
                                    max={formattedToday}
                                />
                            </div>
                        </div>
                        <div className="col-md-4" >
                            <CenterModal onSelectCenter={handleSelectedCenter} resetTrigger={resetTrigger} />

                            {/* <CenterModal onSelectCenter={handleSelectedCenter} /> */}
                        </div>
                    </div>

                    <div className="filter-actions">
                        <button
                            className="btn-modern btn-modern-primary"
                            onClick={handleApplyFilter}
                            disabled={loading}
                        >
                            <i className="mdi mdi-check"></i>   {loading ? "Applying..." : "Apply Filter"}
                        </button>
                        <button
                            className="btn-modern btn-modern-outline"
                            onClick={handleClearFilter}
                        >
                            <i className="mdi mdi-close"></i> Clear Filter
                        </button>
                        <div className="d-flex justify-content-between align-items-center">
                            {activeTab !== "payment" && (
                                <button
                                    className="btn-modern btn-modern-outline"
                                    onClick={downloadCSV}
                                    style={{
                                        backgroundColor: "#1D6F42",
                                        color: "#fff",
                                        border: "none",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        padding: "8px 14px",
                                        borderRadius: "6px",
                                        fontWeight: "500",
                                    }}
                                >
                                    <i className="mdi mdi-google-spreadsheet"></i> Export to Excel
                                </button>
                            )}

                        </div>

                    </div>

                </div>
            )}

            {activeTab === "party" && (
                <div className="modern-table-container">
                    <div className="modern-table-header">
                        <div className="modern-table-title">Party Collection ({totalPartyCount})</div>
                    </div>
                    <div className="p-4 text-center">
                        <div className="modern-table-container">

                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-bordered text-center">
                                        <thead className="table-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Type</th>
                                                <th>Item Name</th>
                                                <th>Net Sale</th>
                                                {taxRate
                                                    ?.filter((tax) => tax.is_active)
                                                    ?.sort((a, b) => a.rate - b.rate)
                                                    ?.map((tax) => (
                                                        <th key={tax.id}>{`${tax.rate}% GST`}</th>
                                                    ))}
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {partyGst.length > 0 ? (
                                                // console.log("party gst..", partyGst),
                                                partyGst.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item?.type || "N/A"}</td>
                                                        <td>{item?.item_name || "N/A"}</td>
                                                        <td>{item["Net Sale"] || 0}</td>

                                                        {taxRate
                                                            ?.filter((tax) => tax.is_active)
                                                            ?.sort((a, b) => a.rate - b.rate)
                                                            ?.map((tax) => {
                                                                const key = `GST ${tax.rate} %`;
                                                                return <td key={tax.id}>{item[key] ?? 0}</td>;
                                                            })}
                                                        <td>{item.total}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="11">No data available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <nav>
                                        <ul className="pagination justify-content-center mt-4">
                                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(currentPage - 1)}
                                                >
                                                    Previous
                                                </button>
                                            </li>

                                            {getPageNumbers().map((page, index) => (
                                                <li
                                                    key={index}
                                                    className={`page-item ${page === currentPage ? "active" : ""}`}
                                                >
                                                    <button className="page-link" onClick={() => handlePageChange(page)}>
                                                        {page}
                                                    </button>
                                                </li>
                                            ))}

                                            <li
                                                className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                                    }`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                >
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            )}

            {activeTab === "Reversel-Report" && (
                <div className="modern-table-container">
                    <div className="modern-table-header">
                        <div className="modern-table-title">Reversel Report ({reverselCount})</div>
                    </div>
                    <div className="p-4 text-center">
                        <div className="modern-table-container">

                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-bordered text-center">
                                        <thead className="table-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Card No</th>
                                                <th>CreatedAt</th>
                                                <th>Product name</th>
                                                <th>Employee Name</th>
                                                <th>Reversed Sky coins </th>
                                                <th>Center </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reverseCoins.length > 0 ? (

                                                reverseCoins.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item?.card_number || "N/A"}</td>
                                                        <td>{item?.createdAt || "N/A"}</td>
                                                        <td>{item?.product_name || "N/A"}</td>
                                                        <td>{item?.employee_name || "N/A"}</td>
                                                        <td>{item?.reversed_sky_coin || "N/A"}</td>
                                                        <td>{item?.center || "N/A"}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="11">No data available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <nav>
                                        <ul className="pagination justify-content-center mt-4">
                                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(currentPage - 1)}
                                                >
                                                    Previous
                                                </button>
                                            </li>

                                            {getPageNumbers().map((page, index) => (
                                                <li
                                                    key={index}
                                                    className={`page-item ${page === currentPage ? "active" : ""}`}
                                                >
                                                    <button className="page-link" onClick={() => handlePageChange(page)}>
                                                        {page}
                                                    </button>
                                                </li>
                                            ))}

                                            <li
                                                className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                                    }`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                >
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            )}
            {activeTab === "non-party" && selectedReport === "report1" && (
                <>
                    {radioFilter ? (

                        <div className="modern-table-container">
                            <div className="modern-table-header">
                                <div className="modern-table-title">GST Report Details (<b>{totalCount}</b>)</div>
                            </div>
                            <div className="p-0">
                                <div className="table-responsive">
                                    <table className="table table-bordered text-center">
                                        <thead className="table-light">
                                            <tr>
                                                <th>#</th>
                                                <th>ID</th>
                                                <th>
                                                    {radioFilter === "product" ? "Product Name" : "Product Category"}
                                                </th>

                                                <th>Net Sale</th>

                                                {finance.length > 0 &&
                                                    Object.keys(finance[0])
                                                        .filter((key) => key.includes("% GST"))
                                                        .sort(
                                                            (a, b) =>
                                                                parseFloat(a.replace("% GST", "")) -
                                                                parseFloat(b.replace("% GST", ""))
                                                        )
                                                        .map((key) => <th key={key}>{key}</th>)
                                                }

                                                <th>Additional Cess</th>
                                                <th>Gross Sale</th>
                                                <th>SkyCoins Exhausted</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {finance.length > 0 ? (
                                                finance.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{(currentPage - 1) * perPage + index + 1}</td>
                                                        <td>
                                                            {radioFilter === "product" ? (
                                                                <span>{item.id}</span>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    onClick={() => getFinanceProductByCategory(item.id, 1)}
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#myModalTaxView"
                                                                    className="btn btn-link p-0"
                                                                    style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                                                                >
                                                                    {item.id}
                                                                </button>
                                                            )}


                                                        </td>


                                                        <td>
                                                            {radioFilter === "product"
                                                                ? item.product_name || "N/A"
                                                                : item.product_category || "N/A"}
                                                        </td>

                                                        <td>{item["Net Sale"] || 0}</td>

                                                        {/* Auto-bind GST values */}
                                                        {Object.keys(item)
                                                            .filter((key) => key.includes("% GST"))
                                                            .sort(
                                                                (a, b) =>
                                                                    parseFloat(a.replace("% GST", "")) -
                                                                    parseFloat(b.replace("% GST", ""))
                                                            )
                                                            .map((key) => (
                                                                <td key={key}>{item[key] ?? 0}</td>
                                                            ))}

                                                        <td>{item["Additional Cess"] || 0}</td>
                                                        <td>{item["Gross Sale"] || 0}</td>
                                                        <td>{item["SkyCoins Exhausted"] || 0}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="11">No data available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <nav>
                                    <ul className="pagination justify-content-center mt-4">
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                            >
                                                Previous
                                            </button>
                                        </li>

                                        {getPageNumbers().map((page, index) => (
                                            <li
                                                key={index}
                                                className={`page-item ${page === currentPage ? "active" : ""}`}
                                            >
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            </li>
                                        ))}

                                        <li
                                            className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                            >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center mt-4 text-muted">
                            Please select a filter above to view the report.
                        </div>
                    )}
                </>

            )
            }

            {selectedReport === "report2" && activeTab == "payment" && (

                <>
                    <div className="modern-table-container">
                        <div className="modern-table-header">
                            <h4 className="card-title mb-0">Payment Collection Details (<b>{payment?.length}</b>)</h4>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-bordered text-center">
                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Payment Type</th>
                                            <th>Quantity</th>
                                            <th>Amount</th>
                                            <th>Percentage</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {payment.length > 0 ? (
                                            payment.map((item, index) => (

                                                <tr key={index}>
                                                    <td>{index + 1}</td>

                                                    <td>{item?.payment_type || "N/A"}</td>
                                                    <td>{item?.quantity || "N/A"}</td>
                                                    <td>{item?.amount || "N/A"}</td>
                                                    <td>{item?.percentage || "N/A"}</td>

                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="11">No data available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {showCoupon === true && (

                <div className="card p-0">
                    <table className="table table-striped text-center">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Coupon Code</th>
                                <th>Recharge(Count/Amount)</th>
                                <th>Package(Count/Amount)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {consolidatedCuoponReport.length > 0 ? (
                                consolidatedCuoponReport.map((item, index) => {
                                    const recharge = JSON.parse(item.recharge);
                                    const pack = JSON.parse(item.package);

                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>

                                                {item.code}</td>
                                            <td>
                                                <button type="button" onClick={handleClickOpenrecharge} className="btn btn-sm btn-link">
                                                    {recharge?.count}
                                                </button>
                                                / {recharge?.amount ?? 0}</td>
                                            <td>
                                                <button type="button" onClick={handleClickOpenPackage} className="btn btn-sm btn-link">
                                                    {pack?.count}
                                                </button>

                                                / {pack?.amount ?? 0}</td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="6" className="text-center">
                                        No Data Found
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>

                </div>
            )}


            {showAdRecharge === true && (
                <>
                    <div className="modern-table-container">
                        <div className="modern-table-header">
                            <h4 className="card-title mb-0">Recharge (<b>{playPointsDiscountCount}</b>)</h4>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-bordered table-responsive">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Customer Name</th>
                                            <th>Customer Mobile</th>
                                            <th>Employee Name</th>
                                            <th>Products</th>
                                            <th>Order Amount</th>
                                            <th>Bill Amount</th>
                                            <th>Discount</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {playPointsDiscount.length > 0 ? (
                                            playPointsDiscount.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
                                                    <td>{item.customer_name || "N/A"}</td>
                                                    <td>{item.customer_mobile}</td>
                                                    <td>{item.employee_name}</td>
                                                    <td>{item.product_names}</td>
                                                    <td>{item.order_amount}</td>
                                                    <td>{item.bill_amount}</td>
                                                    <td>{item.discount_amount}</td>
                                                    <td>{item.createdAt}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="9" className="text-center text-danger">
                                                    No Records Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <nav>
                                    <ul className="pagination justify-content-center mt-4">
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                            >
                                                Previous
                                            </button>
                                        </li>

                                        {getPageNumbers().map((page, index) => (
                                            <li
                                                key={index}
                                                className={`page-item ${page === currentPage ? "active" : ""}`}
                                            >
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            </li>
                                        ))}

                                        <li
                                            className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                            >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </>



            )}
            {showAdCombo === true && (

                <>
                    <div className="modern-table-container">
                        <div className="modern-table-header">
                            <h4 className="card-title mb-0">Combo Product Details (<b>{pointsDiscountReportCount}</b>)</h4>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Customer Name</th>
                                            <th>Customer Mobile</th>
                                            <th>Employee Name</th>
                                            <th>Products Name</th>
                                            <th>Order Amount</th>
                                            <th>Bill Amount</th>
                                            <th>Manual Discount</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {pointsDiscountReport.length > 0 ? (
                                            pointsDiscountReport.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.customer_name}</td>
                                                    <td>{item.customer_mobile}</td>
                                                    <td>{item.employee_name}</td>
                                                    <td>{item.product_names}</td>
                                                    <td>{item.order_amount}</td>
                                                    <td>{item.bill_amount}</td>
                                                    <td>{item.manual_discount}</td>
                                                    <td>{item.createdAt}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="9" className="text-center text-danger">
                                                    No Records Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <nav>
                                    <ul className="pagination justify-content-center mt-4">
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                            >
                                                Previous
                                            </button>
                                        </li>

                                        {getPageNumbers().map((page, index) => (
                                            <li
                                                key={index}
                                                className={`page-item ${page === currentPage ? "active" : ""}`}
                                            >
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            </li>
                                        ))}

                                        <li
                                            className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                            >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>

                </>
            )}

            {showParty === true && (

                <>
                    <div className="modern-table-container">
                        <div className="modern-table-header">
                            <h4 className="card-title mb-0">Party  Details (<b>{partyDiscountReportCount}</b>)</h4>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Customer Name</th>
                                            <th>Mobile</th>
                                            <th>Employee</th>
                                            <th>Order Amount</th>
                                            <th>Bill Amount</th>
                                            <th>Discount Amount</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {partyDiscountReport.length > 0 ? (
                                            partyDiscountReport.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.customer_name}</td>
                                                    <td>{item.customer_mobile}</td>
                                                    <td>{item.employee_name}</td>
                                                    <td>{item.order_amount}</td>
                                                    <td>{item.bill_amont}</td>
                                                    <td>{item.discount_amount}</td>
                                                    <td>{item.createdAt}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center">No data found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <nav>
                                    <ul className="pagination justify-content-center mt-4">
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                            >
                                                Previous
                                            </button>
                                        </li>

                                        {getPageNumbers().map((page, index) => (
                                            <li
                                                key={index}
                                                className={`page-item ${page === currentPage ? "active" : ""}`}
                                            >
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            </li>
                                        ))}

                                        <li
                                            className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                            >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>

                </>
            )}

            {showCouponDetails === true && (
                <div
                    className="modal fade show"
                    tabIndex="-1"
                    aria-hidden="true"
                    onClick={() => setShowCouponDetails(false)}
                    style={{
                        display: "block",
                        background: "rgba(0,0,0,0.5)"
                    }}

                >
                    <div
                        className="modal-dialog modal-lg"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Recharge{" "}
                                    <button className="btn btn-primary btn-sm" onClick={downloadCSVRecharge}>
                                        <i className="fa fa-download"></i>
                                    </button>
                                </h5>
                                <button type="button" className="btn-close" onClick={() => setShowCouponDetails(false)}></button>
                            </div>


                            <div className="modal-body">
                                <div className="card p-0">
                                    <table className="table table-striped text-center">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Customer Name</th>
                                                <th>Customer Mobile</th>
                                                <th>Coupon Code</th>
                                                <th>Order Amount</th>
                                                <th>Coupon Discount Amount</th>
                                                <th>Created At</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {couponDetailList.length > 0 ? (
                                                couponDetailList.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.customer_name ?? "N/A"}</td>
                                                        <td>{item.customer_mobile}</td>
                                                        <td>{item.coupon_code}</td>
                                                        <td>{item.order_amount}</td>
                                                        <td>{item.coupon_discount_amount}</td>
                                                        <td>{item.createdAt}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center">
                                                        No Data Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                    {/* Pagination */}
                                    <nav>
                                        <ul className="pagination justify-content-center mt-4">
                                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(currentPage - 1)}
                                                >
                                                    Previous
                                                </button>
                                            </li>

                                            {getPageNumbers().map((page, index) => (
                                                <li
                                                    key={index}
                                                    className={`page-item ${page === currentPage ? "active" : ""}`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        onClick={() => handlePageChange(page)}
                                                    >
                                                        {page}
                                                    </button>
                                                </li>
                                            ))}

                                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                >
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            )}


            {showPackageDetails === true && (
                <div
                    className="modal fade show"
                    // id={id}
                    tabIndex="-1"
                    aria-hidden="true"
                    onClick={() => setShowPackageDetails(false)}
                    style={{
                        display: "block",
                        background: "rgba(0,0,0,0.5)"
                    }}
                >
                    <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Package   <button className="btn btn-primary btn-sm" onClick={downloadCSVPackage}>
                                    <i className="fa fa-download"></i>
                                </button></h5>

                                <button type="button" className="btn-close" ></button>
                            </div>
                            <div className="modal-body">
                                <div className="card p-0">
                                    <table className="table table-striped text-center">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Customer Name</th>
                                                <th>Customer Mobile</th>
                                                <th>Coupon Code</th>
                                                <th>Order Amount</th>
                                                <th>Coupon Discount Amount</th>
                                                <th>CreatedAt</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {packageDetailList.length > 0 ? (
                                                packageDetailList.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.customer_name ?? "N/A"}</td>
                                                        <td>{item.customer_mobile}</td>
                                                        <td>{item.coupon_code}</td>
                                                        <td>{item.order_amount}</td>
                                                        <td>{item.coupon_discount_amount}</td>
                                                        <td>{item.createdAt}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center">
                                                        No Data Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <nav>
                                        <ul className="pagination justify-content-center mt-4">
                                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(currentPage - 1)}
                                                >
                                                    Previous
                                                </button>
                                            </li>

                                            {getPageNumbers().map((page, index) => (
                                                <li
                                                    key={index}
                                                    className={`page-item ${page === currentPage ? "active" : ""}`}
                                                >
                                                    <button className="page-link" onClick={() => handlePageChange(page)}>
                                                        {page}
                                                    </button>
                                                </li>
                                            ))}

                                            <li
                                                className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                                    }`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                >
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


            )}

            <section>
                <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Finance Activities</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered text-center">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>ID</th>
                                                <th>Product Name</th>
                                                <th>Net Sale</th>
                                                {taxRate
                                                    ?.filter((tax) => tax.is_active)
                                                    ?.sort((a, b) => a.rate - b.rate)
                                                    ?.map((tax) => (
                                                        <th key={tax.id}>{`${tax.rate}% GST`}</th>
                                                    ))}

                                                <th>Additional Cess</th>
                                                <th>Gross Sale</th>
                                                <th>SkyCoins Exhausted</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {financeProduct.length > 0 ? (
                                                financeProduct.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.id}</td>
                                                        <td>{item.product_name}</td>
                                                        <td>{item["Net Sale"]}</td>
                                                        {taxRate
                                                            ?.filter((tax) => tax.is_active)
                                                            ?.sort((a, b) => a.rate - b.rate)
                                                            ?.map((tax) => {
                                                                const key = `${tax.rate}% GST`;
                                                                return <td key={tax.id}>{item[key] ?? 0}</td>;
                                                            })}
                                                        <td>{item["Additional Cess"]}</td>
                                                        <td>{item["Gross Sale"]}</td>
                                                        <td>{item["SkyCoins Exhausted"]}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="11">No data found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <nav>
                                    <ul className="pagination justify-content-center mt-4">
                                        <li className={`page-item   ${productPage === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => getFinanceProductId(productId, productPage - 1)}>
                                                Previous
                                            </button>
                                        </li>

                                        {getProductPageNumbers().map((page, index) => (
                                            <li key={index} className={`page-item ${page === productPage ? "active" : ""}`}>
                                                {page === "..." ? (
                                                    <span className="page-link">...</span>
                                                ) : (
                                                    <button
                                                        className="page-link"
                                                        onClick={() => getFinanceProductByCategory(productId, page)}>
                                                        {page}
                                                    </button>
                                                )}
                                            </li>
                                        ))}

                                        <li className={`page-item ${productPage === productTotalPages ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => getFinanceProductByCategory(productId, productPage + 1)}>
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </section>


            <ToastContainer />
        </div >
    );
};

export default FinanceReportCopy;